import { createSelector } from "@reduxjs/toolkit";

import { MIN_BILLING_YEAR } from "../consts/billing";
import { RootState } from "../store";
import { BillingBlockReason, BillingStatus } from "../types/billings";
import { Status } from "../types/state";

export const getBillings = (state: RootState) => state.billings;
export const getBillingsListStatus = (state: RootState) => state.billings.status;
export const getIsBillingsListStatusLoading = (state: RootState): boolean => state.billings.status !== Status.success;

export const getBillingsListErrorMsg = (state: RootState) => state.billings.errorMsg;

export const getBillingsList = (state: RootState) => state.billings.list;

export const getBillingsListNextPageState = (state: RootState) => state.billings.isNextPageEnable;
export const getBillingsListScrollTop = (state: RootState) => state.billings.scrollTop;

export const getBillingsHasNewStatus = createSelector([getBillingsList], (list) =>
  list.some((b) => b.status === BillingStatus.New)
);
export const getBillingsHasActiveStatus = createSelector([getBillingsList], (list) =>
  list.some((b) => b.status === BillingStatus.Active)
);

export const getBillingsCreateAvailableYears = createSelector([getBillingsList], (list): number[] => {
  const MAX_YEAR = new Date().getFullYear();

  const existingYears = list.map((b) => b.year);
  const availableYears: number[] = [];

  for (let year = MAX_YEAR; year >= MIN_BILLING_YEAR; year--) {
    if (!existingYears.includes(year)) {
      availableYears.push(year);
    }
  }

  return availableYears;
});

export const getBillingsNewBillingBlockReason = createSelector(
  [getBillingsCreateAvailableYears, getBillingsHasNewStatus, getBillingsHasActiveStatus],
  (availableYears, hasNewStatus, hasActiveStatus): BillingBlockReason | null => {
    if (hasNewStatus || hasActiveStatus) {
      return BillingBlockReason.OnlyOneActive;
    }
    if (availableYears.length === 0) {
      return BillingBlockReason.NoAvailableYear;
    }
    return null;
  }
);
